var map = {
	"./assets/audio/ArcadeWin.ogg": 9,
	"./assets/audio/Bells.ogg": 10,
	"./assets/audio/BigWin.ogg": 11,
	"./assets/audio/BonusWheel_MUSIC_END.ogg": 12,
	"./assets/audio/BonusWheel_MUSIC_LOOP.ogg": 13,
	"./assets/audio/GlitterAir.ogg": 14,
	"./assets/audio/Skeeballthrowroll.ogg": 15,
	"./assets/audio/ballHit1.ogg": 16,
	"./assets/audio/ballHopper.ogg": 17,
	"./assets/audio/balltrayFill.ogg": 18,
	"./assets/audio/beeda_loo.ogg": 19,
	"./assets/audio/blip.ogg": 20,
	"./assets/audio/clack1.ogg": 21,
	"./assets/audio/extraBall.ogg": 22,
	"./assets/audio/failSound.ogg": 23,
	"./assets/audio/fallinHole.ogg": 24,
	"./assets/audio/hit.ogg": 25,
	"./assets/audio/hit2.ogg": 26,
	"./assets/audio/inHole.ogg": 27,
	"./assets/audio/ramp.ogg": 28,
	"./assets/audio/ramp2.ogg": 29,
	"./assets/audio/rampRoll.ogg": 30,
	"./assets/audio/rolldown.ogg": 31,
	"./assets/audio/snare.ogg": 32,
	"./assets/audio/squirtle.ogg": 33,
	"./site/MD/build/audio/ArcadeWin.ogg": 34,
	"./site/MD/build/audio/Bells.ogg": 35,
	"./site/MD/build/audio/BigWin.ogg": 36,
	"./site/MD/build/audio/BonusWheel_MUSIC_END.ogg": 37,
	"./site/MD/build/audio/BonusWheel_MUSIC_LOOP.ogg": 38,
	"./site/MD/build/audio/GlitterAir.ogg": 39,
	"./site/MD/build/audio/Skeeballthrowroll.ogg": 40,
	"./site/MD/build/audio/ballHit1.ogg": 41,
	"./site/MD/build/audio/ballHopper.ogg": 42,
	"./site/MD/build/audio/balltrayFill.ogg": 43,
	"./site/MD/build/audio/beeda_loo.ogg": 44,
	"./site/MD/build/audio/blip.ogg": 45,
	"./site/MD/build/audio/clack1.ogg": 46,
	"./site/MD/build/audio/extraBall.ogg": 47,
	"./site/MD/build/audio/failSound.ogg": 48,
	"./site/MD/build/audio/fallinHole.ogg": 49,
	"./site/MD/build/audio/hit.ogg": 50,
	"./site/MD/build/audio/hit2.ogg": 51,
	"./site/MD/build/audio/inHole.ogg": 52,
	"./site/MD/build/audio/ramp.ogg": 53,
	"./site/MD/build/audio/ramp2.ogg": 54,
	"./site/MD/build/audio/rampRoll.ogg": 55,
	"./site/MD/build/audio/rolldown.ogg": 56,
	"./site/MD/build/audio/snare.ogg": 57,
	"./site/MD/build/audio/squirtle.ogg": 58,
	"./site/NY/build/audio/ArcadeWin.ogg": 59,
	"./site/NY/build/audio/Bells.ogg": 60,
	"./site/NY/build/audio/BigWin.ogg": 61,
	"./site/NY/build/audio/BonusWheel_MUSIC_END.ogg": 62,
	"./site/NY/build/audio/BonusWheel_MUSIC_LOOP.ogg": 63,
	"./site/NY/build/audio/GlitterAir.ogg": 64,
	"./site/NY/build/audio/Skeeballthrowroll.ogg": 65,
	"./site/NY/build/audio/ballHit1.ogg": 66,
	"./site/NY/build/audio/ballHopper.ogg": 67,
	"./site/NY/build/audio/balltrayFill.ogg": 68,
	"./site/NY/build/audio/beeda_loo.ogg": 69,
	"./site/NY/build/audio/blip.ogg": 70,
	"./site/NY/build/audio/clack1.ogg": 71,
	"./site/NY/build/audio/extraBall.ogg": 72,
	"./site/NY/build/audio/failSound.ogg": 73,
	"./site/NY/build/audio/fallinHole.ogg": 74,
	"./site/NY/build/audio/hit.ogg": 75,
	"./site/NY/build/audio/hit2.ogg": 76,
	"./site/NY/build/audio/inHole.ogg": 77,
	"./site/NY/build/audio/ramp.ogg": 78,
	"./site/NY/build/audio/ramp2.ogg": 79,
	"./site/NY/build/audio/rampRoll.ogg": 80,
	"./site/NY/build/audio/rolldown.ogg": 81,
	"./site/NY/build/audio/snare.ogg": 82,
	"./site/NY/build/audio/squirtle.ogg": 83,
	"./site/WV/build/audio/ArcadeWin.ogg": 84,
	"./site/WV/build/audio/Bells.ogg": 85,
	"./site/WV/build/audio/BigWin.ogg": 86,
	"./site/WV/build/audio/BonusWheel_MUSIC_END.ogg": 87,
	"./site/WV/build/audio/BonusWheel_MUSIC_LOOP.ogg": 88,
	"./site/WV/build/audio/GlitterAir.ogg": 89,
	"./site/WV/build/audio/Skeeballthrowroll.ogg": 90,
	"./site/WV/build/audio/ballHit1.ogg": 91,
	"./site/WV/build/audio/ballHopper.ogg": 92,
	"./site/WV/build/audio/balltrayFill.ogg": 93,
	"./site/WV/build/audio/beeda_loo.ogg": 94,
	"./site/WV/build/audio/blip.ogg": 95,
	"./site/WV/build/audio/clack1.ogg": 96,
	"./site/WV/build/audio/extraBall.ogg": 97,
	"./site/WV/build/audio/failSound.ogg": 98,
	"./site/WV/build/audio/fallinHole.ogg": 99,
	"./site/WV/build/audio/hit.ogg": 100,
	"./site/WV/build/audio/hit2.ogg": 101,
	"./site/WV/build/audio/inHole.ogg": 102,
	"./site/WV/build/audio/ramp.ogg": 103,
	"./site/WV/build/audio/ramp2.ogg": 104,
	"./site/WV/build/audio/rampRoll.ogg": 105,
	"./site/WV/build/audio/rolldown.ogg": 106,
	"./site/WV/build/audio/snare.ogg": 107,
	"./site/WV/build/audio/squirtle.ogg": 108,
	"./site/demo/build/audio/ArcadeWin.ogg": 109,
	"./site/demo/build/audio/Bells.ogg": 110,
	"./site/demo/build/audio/BigWin.ogg": 111,
	"./site/demo/build/audio/BonusWheel_MUSIC_END.ogg": 112,
	"./site/demo/build/audio/BonusWheel_MUSIC_LOOP.ogg": 113,
	"./site/demo/build/audio/GlitterAir.ogg": 114,
	"./site/demo/build/audio/Skeeballthrowroll.ogg": 115,
	"./site/demo/build/audio/ballHit1.ogg": 116,
	"./site/demo/build/audio/ballHopper.ogg": 117,
	"./site/demo/build/audio/balltrayFill.ogg": 118,
	"./site/demo/build/audio/beeda_loo.ogg": 119,
	"./site/demo/build/audio/blip.ogg": 120,
	"./site/demo/build/audio/clack1.ogg": 121,
	"./site/demo/build/audio/extraBall.ogg": 122,
	"./site/demo/build/audio/failSound.ogg": 123,
	"./site/demo/build/audio/fallinHole.ogg": 124,
	"./site/demo/build/audio/hit.ogg": 125,
	"./site/demo/build/audio/hit2.ogg": 126,
	"./site/demo/build/audio/inHole.ogg": 127,
	"./site/demo/build/audio/ramp.ogg": 128,
	"./site/demo/build/audio/ramp2.ogg": 129,
	"./site/demo/build/audio/rampRoll.ogg": 130,
	"./site/demo/build/audio/rolldown.ogg": 131,
	"./site/demo/build/audio/snare.ogg": 132,
	"./site/demo/build/audio/squirtle.ogg": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;



//////////////////
// WEBPACK FOOTER
// ./app ./~/file-loader?name=audio/[name].ogg!^\.\/.*\.ogg$
// module id = 8
// module chunks = 0